import React from 'react';
import { View } from 'react-native';
import { Text } from '@socrait/react';

import { setupStepStyles } from './setupStepStyles';

export const VoiceNameInstructionsStep = () => {
  return (
    <View style={setupStepStyles.container}>
      <Text style={setupStepStyles.headerText}>
        Let's add some <Text style={setupStepStyles.headerTextPurple}>voice names</Text>
      </Text>
      <View style={[setupStepStyles.contentContainer, setupStepStyles.textContainer]}>
        <Text style={setupStepStyles.text}>
          Voice names are the unique names you use in class to call on your students.
        </Text>
        <Text style={setupStepStyles.text}>
          A voice name could be a nickname, a first name, a last name, or a hybrid like "John A."
        </Text>
        <Text style={setupStepStyles.text}>
          You don't have to add your entire roster now. Just add the students you interact with most. You can come back
          and revise your roster later.
        </Text>
      </View>
    </View>
  );
};
